<template>
    <div id="treasury" class="section alter">
        <h1 class="header">{{ $t("treasury.header") }}<span class="header-dot">.</span></h1>
        <h3 class="introduction">{{ $t("treasury.introduction") }}</h3>
        <div class="header-separator"></div>
        <div class="content">
            <div class="alternating-display">
                <div class="flavour-text">
                    <!-- <h1 class="flavour-header">PAX A35</h1> -->
                    <div class="flavour-description">
                        <br>
                        <p>{{ $t("treasury.flavour-text.line-1") }}</p>
                        <br>
                        <p>{{ $t("treasury.flavour-text.line-2") }}</p>
                        <br>
                    </div>
                    <img class="under-image" src="../../../assets/images/logos/m2payBanner.png" alt="">
                </div>
                <div class="checkmark-list">
                    <div class="list-item">
                        <div class="checkmark-holder"><img src="../../../assets/images/icons/checkmark.png" alt=""></div>
                        <p class="message">{{ $t("treasury.checkmark-list.item-1") }}</p>
                    </div>
                    <div class="list-item">
                        <div class="checkmark-holder"><img src="../../../assets/images/icons/checkmark.png" alt=""></div>
                        <p class="message">{{ $t("treasury.checkmark-list.item-2") }}</p>
                    </div>
                    <div class="list-item">
                        <div class="checkmark-holder"><img src="../../../assets/images/icons/checkmark.png" alt=""></div>
                        <p class="message">{{ $t("treasury.checkmark-list.item-3") }}</p>
                    </div>
                    <div class="list-item">
                        <div class="checkmark-holder"><img src="../../../assets/images/icons/checkmark.png" alt=""></div>
                        <p class="message">{{ $t("treasury.checkmark-list.item-4") }}</p>
                    </div>
                </div>
            </div>
            <div class="diamonds-holder">
                <div class="diamonds-block">
                    <div class="diamond" @mouseenter="messages.block1.message1 = true" @mouseleave="messages.block1.message1 = false">
                        <img class="icon" src="../../../assets/images/diamond-icons/handing-card.png" alt="">
                    </div>
                    <div class="diamond" @mouseenter="messages.block1.message2 = true" @mouseleave="messages.block1.message2 = false">
                        <img class="icon" src="../../../assets/images/diamond-icons/euro.png" alt="">
                    </div>
                    <div class="diamond" @mouseenter="messages.block1.message3 = true" @mouseleave="messages.block1.message3 = false">
                        <img class="icon" src="../../../assets/images/diamond-icons/headset.png" alt="">
                    </div>
                    <div class="diamond" @mouseenter="messages.block1.message4 = true" @mouseleave="messages.block1.message4 = false">
                        <img class="icon" src="../../../assets/images/diamond-icons/free.png" alt="">
                    </div>
                </div>
                <div class="diamonds-block">
                    <div class="diamond" @mouseenter="messages.block2.message1 = true" @mouseleave="messages.block2.message1 = false">
                        <img class="icon" src="../../../assets/images/diamond-icons/currency.png" alt="">
                    </div>
                    <div class="diamond" @mouseenter="messages.block2.message2 = true" @mouseleave="messages.block2.message2 = false">
                        <img class="icon" src="../../../assets/images/diamond-icons/mastercard.png" alt="">
                    </div>
                    <div class="diamond" @mouseenter="messages.block2.message3 = true" @mouseleave="messages.block2.message3 = false">
                        <img class="icon" src="../../../assets/images/diamond-icons/bank.png" alt="">
                    </div>
                    <div class="diamond" @mouseenter="messages.block2.message4 = true" @mouseleave="messages.block2.message4 = false">
                        <img class="icon" src="../../../assets/images/diamond-icons/wifi.png" alt="">
                    </div>
                </div>
                <div class="diamonds-block">
                    <div class="diamond" @mouseenter="messages.block3.message1 = true" @mouseleave="messages.block3.message1 = false">
                        <img class="icon" src="../../../assets/images/diamond-icons/person.png" alt="">
                    </div>
                    <div class="diamond" @mouseenter="messages.block3.message2 = true" @mouseleave="messages.block3.message2 = false">
                        <img class="icon" src="../../../assets/images/diamond-icons/cog.png" alt="">
                    </div>
                    <div class="diamond" @mouseenter="messages.block3.message3 = true" @mouseleave="messages.block3.message3 = false">
                        <img class="icon" src="../../../assets/images/diamond-icons/puzzle-piece.png" alt="">
                    </div>
                    <div class="diamond" @mouseenter="messages.block3.message4 = true" @mouseleave="messages.block3.message4 = false">
                        <img class="icon" src="../../../assets/images/diamond-icons/magnifing-glass.png" alt="">
                    </div>
                </div>
                <div class="diamonds-block">
                    
                </div>
            </div>
            <div class="diamond-messages">
                <Transition name="message">
                    <p class="message" v-if="messages.block1.message1">{{ $t("treasury.diamond-blocks.block-1.message-1") }}</p>
                </Transition>
                <Transition name="message">
                    <p class="message" v-if="messages.block1.message2">{{ $t("treasury.diamond-blocks.block-1.message-2") }}</p>
                </Transition>
                <Transition name="message">
                    <p class="message" v-if="messages.block1.message3">{{ $t("treasury.diamond-blocks.block-1.message-3") }}</p>
                </Transition>
                <Transition name="message">
                    <p class="message" v-if="messages.block1.message4">{{ $t("treasury.diamond-blocks.block-1.message-4") }}</p>
                </Transition>

                <Transition name="message">
                    <p class="message" v-if="messages.block2.message1">{{ $t("treasury.diamond-blocks.block-2.message-1") }}</p>
                </Transition>
                <Transition name="message">
                    <p class="message" v-if="messages.block2.message2">{{ $t("treasury.diamond-blocks.block-2.message-2") }}</p>
                </Transition>
                <Transition name="message">
                    <p class="message" v-if="messages.block2.message3">{{ $t("treasury.diamond-blocks.block-2.message-3") }}</p>
                </Transition>
                <Transition name="message">
                    <p class="message" v-if="messages.block2.message4">{{ $t("treasury.diamond-blocks.block-2.message-4") }}</p>
                </Transition>

                <Transition name="message">
                    <p class="message" v-if="messages.block3.message1">{{ $t("treasury.diamond-blocks.block-3.message-1") }}</p>
                </Transition>
                <Transition name="message">
                    <p class="message" v-if="messages.block3.message2">{{ $t("treasury.diamond-blocks.block-3.message-2") }}</p>
                </Transition>
                <Transition name="message">
                    <p class="message" v-if="messages.block3.message3">{{ $t("treasury.diamond-blocks.block-3.message-3") }}</p>
                </Transition>
                <Transition name="message">
                    <p class="message" v-if="messages.block3.message4">{{ $t("treasury.diamond-blocks.block-3.message-4") }}</p>
                </Transition>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                messages: {
                    block1: {
                        message1: false,
                        message2: false,
                        message3: false,
                        message4: false,
                    },
                    block2: {
                        message1: false,
                        message2: false,
                        message3: false,
                        message4: false,
                    },
                    block3: {
                        message1: false,
                        message2: false,
                        message3: false,
                        message4: false,
                    }
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    #treasury {
        .content {

            .diamonds-holder {
                display: flex;
                flex-wrap: wrap;
                justify-content: center;
                margin-left: auto;
                margin-right: auto;
                margin-top: 100px;
                width: 480px;
                height: 480px;
                transform: rotate(45deg);

                @media screen and (max-width: 800px) {
                    &.diamonds-holder {
                        display: none;
                        // margin-top: 0px;
                        // margin-left: none;
                        // transform: scale(0.6) rotate(45deg);
                    }
                }

                .diamonds-block {
                    width: 220px;
                    height: 220px;
                    margin: 10px;
                    display: flex;
                    flex-wrap: wrap;

                    .diamond {
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        margin: 5px;
                        width: 100px;
                        height: 100px;
                        padding: 10px;
                        background-color: var(--signature);
                        box-shadow: 6px 6px 12px rgba(0, 0, 0, 0.3);
                        cursor: pointer;
                        transition: 0.5s;

                        &:hover {
                            transform: scale(1.1);
                            background-color: var(--hover);
                            box-shadow: 6px 6px 12px rgba(0, 0, 0, 0.5);

                            .icon {
                                opacity: 1;
                            }
                        }

                        .icon {
                            width: 52px;
                            transform: rotate(-45deg);
                            opacity: 0.6;
                            transition: 0.5s;
                        }
                    }
                }
            }

            .diamond-messages {
                position: relative;
                height: 100px;
                width: 100%;

                @media screen and (max-width: 800px) {
                    &.diamonds-messages {
                        display: none;
                        // margin-top: 0px;
                        // margin-left: none;
                        // transform: scale(0.6) rotate(45deg);
                    }
                }

                .message-default {

                }

                .message {
                    position: absolute;
                    // top: 50px;
                    width: 100%;
                    text-align: center;
                    font-size: 30px;
                    font-weight: bold;
                    color: var(--signature);
                }

                .message-enter-active {
                    animation: message 0.5s forwards ease-out;
                }

                .message-leave-active {
                    animation: message 0.5s forwards ease-out reverse;
                }

                @keyframes message {
                    0% {
                        top: -50px;
                        opacity: 0;
                    }
                    100% {
                        top: 0px;
                        opacity: 1;
                    }
                }
            }
        }
    }
</style>